export const strings = {
  en: {
    impactShareButton: () => `Share to Grow Your Impact`,
    impactShareText: ({ brandName = "" }) =>
      `Help ${brandName} reach their giving goal by sharing this cause on social media`,
    impactShareTitle: () => `Share on Social Media`,
    impactShareCopy: () => `Copy`,
    impactShareDownload: () => `Download`,
    impactShareClose: () => `Close`,
  },
  fr: {
    impactShareButton: () => `Partagez pour augmentez votre cause`,
    impactShareText: ({ brandName = "" }) =>
      `Aidez ${brandName} a atteindre leur objectif en partageant cette cause sur votre réseaux sociaux`,
    impactShareTitle: () => `Partager sur votre réseaux sociaux`,
    impactShareCopy: () => `Copier`,
    impactShareDownload: () => `Télécharger`,
    impactShareClose: () => `Fermer`,
  },
  de: {
    impactShareButton: () => `Teil, um unserem Beitrag zu erhöhen`, // TODO: Update translation copy SDK-2210
    impactShareText: ({ brandName = "" }) => `Hilf ${brandName} ihre Spendenziel zu erreichen`,
    impactShareTitle: () => `In den sozialen Medien teilen`,
    impactShareCopy: () => `Kopieren`,
    impactShareDownload: () => `Herunterladen`,
    impactShareClose: () => `Schließen`,
  },
  es: {
    impactShareButton: () => "Comparte para aumentar nuestro impacto", // TODO: Update translation copy SDK-2210
    impactShareText: ({ brandName = "" }) =>
      `Comparte en las redes sociales para ayudar a ${brandName} a alcanzar su objetivo.`,
    impactShareTitle: () => "Compartir en redes sociales",
    impactShareCopy: () => "Copiar",
    impactShareDownload: () => "Descargar",
    impactShareClose: () => "Cerrar",
  },
  it: {
    impactShareButton: () => "Condividi, aiutaci a fare la differenza", // TODO: Update translation copy SDK-2210
    impactShareText: ({ brandName = "" }) =>
      `Aiuta ${brandName} a raggiungere il suo obiettivo di donazione condividendo questa causa sui social media.`,
    impactShareTitle: () => "Condividi, aiutaci a fare la differenza",
    impactShareCopy: () => "Copia",
    impactShareDownload: () => "Scarica",
    impactShareClose: () => "Chiudi",
  },
  pl: {
    impactShareButton: () => `Udostępnij, by szerzyć naszą misję`, // TODO: Update translation copy SDK-2210
    impactShareText: ({ brandName = "" }) =>
      `Pomóż ${brandName} osiągnąć cel i podziel się tą inicjatywą na swoim profilu`,
    impactShareTitle: () => `Udostępnij na swoim profilu`,
    impactShareCopy: () => `Kopiuj`,
    impactShareDownload: () => `Pobierz`,
    impactShareClose: () => `Zamknij`,
  },
  ja: {
    impactShareButton: () => `活動の輪を広げよう`,
    impactShareText: ({ brandName = "" }) =>
      `${brandName}の寄付目標達成に向けて、SNSでこの活動を是非シェアしてください。`,
    impactShareTitle: () => `SNSでシェアする`,
    impactShareCopy: () => `コピー`,
    impactShareDownload: () => `ダウンロード`,
    impactShareClose: () => `閉じる`,
  },
};
